module.exports = __webpack_public_path__ + "static/media/Osama.7bba8f85.jpeg";